import { APIClient } from "./api_helper";

import * as url from "./url_helper";
// User Profile - ADDED
import { UserProfile as IUserProfile } from '../pages/Authentication/UserProfile/types';

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = sessionStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
export const postFakeRegister = (data : any) => api.create(url.POST_FAKE_REGISTER, data);

// Login Method
export const postFakeLogin = (data : any) => api.create(url.POST_FAKE_LOGIN, data);

// Refresh access token bằng refresh_token đang lưu — trả về TokenDto mới (access_token/refresh_token/expires_in)
export const postRefreshToken = (data: { refresh_token: string }) => api.create(url.POST_REFRESH_TOKEN, data);

// postForgetPwd
export const postFakeForgetPwd = (data : any) => api.create(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
export const postJwtProfile = (data : any) => api.create(url.POST_EDIT_JWT_PROFILE, data);

export const postFakeProfile = (data : any) => api.update(url.POST_EDIT_PROFILE + '/' + data.idx, data);

// Register Method
export const postJwtRegister = (url : string, data  :any) => {
  return api.create(url, data)
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
export const postJwtLogin = (data : any) => api.create(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
export const postJwtForgetPwd = (data : any) => api.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);
export const postJwtResetPassword = (data: { email: string; token: string; newPassword: string; confirmPassword: string }) =>
  api.create(url.POST_JWT_PASSWORD_RESET, data);

// postSocialLogin
export const postSocialLogin = (data : any) => api.create(url.SOCIAL_LOGIN, data);

// Calendar
// get Events
export const getEvents = () => api.get(url.GET_EVENTS);

// get Events
export const getCategories = () => api.get(url.GET_CATEGORIES);

// get Upcomming Events
export const getUpCommingEvent = () => api.get(url.GET_UPCOMMINGEVENT);

// add Events
export const addNewEvent = (event : any) => api.create(url.ADD_NEW_EVENT, event);

// update Event
export const updateEvent = (event : any) => api.put(url.UPDATE_EVENT, event);

// delete Event
export const deleteEvent = (event : any) => api.delete(url.DELETE_EVENT, { headers: { event } });

// Chat
// get Contact
export const getDirectContact = () => api.get(url.GET_DIRECT_CONTACT);

// get Messages
export const getMessages = (roomId : any) => api.get(`${url.GET_MESSAGES}/${roomId}`, { params: { roomId } });

// add Message
export const addMessage = (message : any) => api.create(url.ADD_MESSAGE, message);

// add Message
export const deleteMessage = (message : any) => api.delete(url.DELETE_MESSAGE, { headers: { message } });

// get Channels
export const getChannels = () => api.get(url.GET_CHANNELS);

// MailBox
//get Mail
export const getMailDetails = () => api.get(url.GET_MAIL_DETAILS);

// delete Mail
export const deleteMail = (forId: any) => api.delete(url.DELETE_MAIL, { headers: { forId } });

// unread Mail
export const unreadMail = (forId: any) => api.delete(url.UNREAD_MAIL, { headers: { forId } });

// star Mail
export const staredMail = (forId: any) => api.delete(url.STARED_MAIL, { headers: { forId } });

// label Mail
export const labelMail = (forId: any) => api.delete(url.LABEL_MAIL, { headers: { forId } });

// trash Mail
export const trashMail = (forId: any) => api.delete(url.TRASH_MAIL, { headers: { forId } });

// Ecommerce
// get Products
export const getProducts = () => api.get(url.GET_PRODUCTS);

// delete Product
export const deleteProducts = (product : any) => api.delete(url.DELETE_PRODUCT, { headers: { product } } );  

// add Products
export const addNewProduct = (product : any) => api.create(url.ADD_NEW_PRODUCT, product);
// update Products
export const updateProduct = (product : any) => api.update(url.UPDATE_PRODUCT, product ); 

// get Orders
export const getOrders = () => api.get(url.GET_ORDERS);

// add Order
export const addNewOrder = (order : any) => api.create(url.ADD_NEW_ORDER, order);

// update Order
export const updateOrder = (order : any) => api.update(url.UPDATE_ORDER, order);

// delete Order
export const deleteOrder = (order : any) => api.delete(url.DELETE_ORDER , { headers: { order } });

// get Customers
export const getCustomers = () => api.get(url.GET_CUSTOMERS);

// add Customers
export const addNewCustomer = (customer : any) => api.create(url.ADD_NEW_CUSTOMER, customer);

// update Customers
export const updateCustomer = (customer : any) => api.update(url.UPDATE_CUSTOMER, customer);

// delete Customers
export const deleteCustomer = (customer : any) => api.delete(url.DELETE_CUSTOMER, { headers: { customer } });

// get Sellers
export const getSellers = () => api.get(url.GET_SELLERS);

// Project
// get Project list 
export const getProjectList = () => api.get(url.GET_PROJECT_LIST);

// Tasks
// get Task
export const getTaskList = () => api.get(url.GET_TASK_LIST);

// add Task
export const addNewTask = (task : any) => api.create(url.ADD_NEW_TASK, task);

// update Task
export const updateTask = (task : any) => api.update(url.UPDATE_TASK, task);

// delete Task
export const deleteTask = (task : any) => api.delete(url.DELETE_TASK, { headers: { task }});

// Kanban Board
export const getTasks = () => api.get(url.GET_TASKS);
export const addNewTasks = (card: any) => api.create(url.ADD_TASKS, card)
export const updateTasks = (card: any) => api.put(url.UPDATE_TASKS, card)
export const deleteTasks = (card: any) => api.delete(url.DELETE_TASKS, { headers: {card} })

// CRM
// get Contacts
export const getContacts = () => api.get(url.GET_CONTACTS);

// add Contact
export const addNewContact = (contact : any) => api.create(url.ADD_NEW_CONTACT, contact);

// update Contact
export const updateContact = (contact : any) => api.update(url.UPDATE_CONTACT, contact);

// delete Contact
export const deleteContact = (contact : any) => api.delete(url.DELETE_CONTACT, { headers: { contact }});

// get Companies
export const getCompanies = () => api.get(url.GET_COMPANIES);

// add Companies
export const addNewCompanies = (company : any) => api.create(url.ADD_NEW_COMPANIES, company);

// update Companies
export const updateCompanies = (company : any) => api.update(url.UPDATE_COMPANIES, company);

// delete Companies
export const deleteCompanies = (company : any) => api.delete(url.DELETE_COMPANIES, { headers: {company}});

// get Deals
export const getDeals = () => api.get(url.GET_DEALS);

// get Leads
export const getLeads = () => api.get(url.GET_LEADS);

// add Lead
export const addNewLead = (lead : any) => api.create(url.ADD_NEW_LEAD, lead);

// update Lead
export const updateLead = (lead : any) => api.update(url.UPDATE_LEAD, lead);

// delete Lead
export const deleteLead = (lead : any) => api.delete(url.DELETE_LEAD, { headers: {lead}});

// Crypto
// Transation
export const getTransationList = () => api.get(url.GET_TRANSACTION_LIST);

// Order List
export const getOrderList = () => api.get(url.GET_ORDRER_LIST);

// Invoice
//get Invoice
export const getInvoices = () => api.get(url.GET_INVOICES);

// add Invoice
export const addNewInvoice = (invoice : any) => api.create(url.ADD_NEW_INVOICE, invoice);

// update Invoice
export const updateInvoice = (invoice : any) => api.update(url.UPDATE_INVOICE + '/' + invoice._id, invoice);

// delete Invoice
export const deleteInvoice = (invoice : any) => api.delete(url.DELETE_INVOICE + '/' + invoice);

// Support Tickets 
// Tickets
export const getTicketsList = () => api.get(url.GET_TICKETS_LIST);

// add Tickets 
export const addNewTicket = (ticket : any) => api.create(url.ADD_NEW_TICKET, ticket);

// update Tickets 
export const updateTicket = (ticket : any) => api.update(url.UPDATE_TICKET, ticket);

// delete Tickets 
export const deleteTicket = (ticket : any) => api.delete(url.DELETE_TICKET, { headers: {ticket}});

// Dashboard Analytics

// Sessions by Countries
export const getAllData = () => api.get(url.GET_ALL_DATA);
export const getHalfYearlyData = () => api.get(url.GET_HALFYEARLY_DATA);
export const getMonthlyData = () => api.get(url.GET_MONTHLY_DATA);

// Audiences Metrics
export const getAllAudiencesMetricsData = () => api.get(url.GET_ALLAUDIENCESMETRICS_DATA);
export const getMonthlyAudiencesMetricsData = () => api.get(url.GET_MONTHLYAUDIENCESMETRICS_DATA);
export const getHalfYearlyAudiencesMetricsData = () => api.get(url.GET_HALFYEARLYAUDIENCESMETRICS_DATA);
export const getYearlyAudiencesMetricsData = () => api.get(url.GET_YEARLYAUDIENCESMETRICS_DATA);

// Users by Device
export const getTodayDeviceData = () => api.get(url.GET_TODAYDEVICE_DATA);
export const getLastWeekDeviceData = () => api.get(url.GET_LASTWEEKDEVICE_DATA);
export const getLastMonthDeviceData = () => api.get(url.GET_LASTMONTHDEVICE_DATA);
export const getCurrentYearDeviceData = () => api.get(url.GET_CURRENTYEARDEVICE_DATA);

// Audiences Sessions by Country
export const getTodaySessionData = () => api.get(url.GET_TODAYSESSION_DATA);
export const getLastWeekSessionData = () => api.get(url.GET_LASTWEEKSESSION_DATA);
export const getLastMonthSessionData = () => api.get(url.GET_LASTMONTHSESSION_DATA);
export const getCurrentYearSessionData = () => api.get(url.GET_CURRENTYEARSESSION_DATA);

// Dashboard CRM

// Balance Overview
export const getTodayBalanceData = () => api.get(url.GET_TODAYBALANCE_DATA);
export const getLastWeekBalanceData = () => api.get(url.GET_LASTWEEKBALANCE_DATA);
export const getLastMonthBalanceData = () => api.get(url.GET_LASTMONTHBALANCE_DATA);
export const getCurrentYearBalanceData = () => api.get(url.GET_CURRENTYEARBALANCE_DATA);

// Dial Type
export const getTodayDealData = () => api.get(url.GET_TODAYDEAL_DATA);
export const getWeeklyDealData = () => api.get(url.GET_WEEKLYDEAL_DATA);
export const getMonthlyDealData = () => api.get(url.GET_MONTHLYDEAL_DATA);
export const getYearlyDealData = () => api.get(url.GET_YEARLYDEAL_DATA);

// Sales Forecast
export const getOctSalesData = () => api.get(url.GET_OCTSALES_DATA);
export const getNovSalesData = () => api.get(url.GET_NOVSALES_DATA);
export const getDecSalesData = () => api.get(url.GET_DECSALES_DATA);
export const getJanSalesData = () => api.get(url.GET_JANSALES_DATA);

// Dashboard Ecommerce
// Revenue
export const getAllRevenueData = () => api.get(url.GET_ALLREVENUE_DATA);
export const getMonthRevenueData = () => api.get(url.GET_MONTHREVENUE_DATA);
export const getHalfYearRevenueData = () => api.get(url.GET_HALFYEARREVENUE_DATA);
export const getYearRevenueData = () => api.get(url.GET_YEARREVENUE_DATA);


// Dashboard Crypto
// Portfolio
export const getBtcPortfolioData = () => api.get(url.GET_BTCPORTFOLIO_DATA);
export const getUsdPortfolioData = () => api.get(url.GET_USDPORTFOLIO_DATA);
export const getEuroPortfolioData = () => api.get(url.GET_EUROPORTFOLIO_DATA);

// Market Graph
export const getAllMarketData = () => api.get(url.GET_ALLMARKETDATA_DATA);
export const getYearMarketData = () => api.get(url.GET_YEARMARKET_DATA);
export const getMonthMarketData = () => api.get(url.GET_MONTHMARKET_DATA);
export const getWeekMarketData = () => api.get(url.GET_WEEKMARKET_DATA);
export const getHourMarketData = () => api.get(url.GET_HOURMARKET_DATA);

// Dashboard Project
// Project Overview
export const getAllProjectData = () => api.get(url.GET_ALLPROJECT_DATA);
export const getMonthProjectData = () => api.get(url.GET_MONTHPROJECT_DATA);
export const gethalfYearProjectData = () => api.get(url.GET_HALFYEARPROJECT_DATA);
export const getYearProjectData = () => api.get(url.GET_YEARPROJECT_DATA);

// Project Status
export const getAllProjectStatusData = () => api.get(url.GET_ALLPROJECTSTATUS_DATA);
export const getWeekProjectStatusData = () => api.get(url.GET_WEEKPROJECTSTATUS_DATA);
export const getMonthProjectStatusData = () => api.get(url.GET_MONTHPROJECTSTATUS_DATA);
export const getQuarterProjectStatusData = () => api.get(url.GET_QUARTERPROJECTSTATUS_DATA);

// dashboard job
export const getApplicationsStatistic = (roomId : any) => api.get(url.GET_JOBAPPLICATIONSTATISTIC, roomId);

// Dashboard NFT
// Marketplace
export const getAllMarketplaceData = () => api.get(url.GET_ALLMARKETPLACE_DATA);
export const getMonthMarketplaceData = () => api.get(url.GET_MONTHMARKETPLACE_DATA);
export const gethalfYearMarketplaceData = () => api.get(url.GET_HALFYEARMARKETPLACE_DATA);
export const getYearMarketplaceData = () => api.get(url.GET_YEARMARKETPLACE_DATA);

// Project
export const addProjectList = (project : any) => api.create(url.ADD_NEW_PROJECT, project);
export const updateProjectList = (project : any) => api.put(url.UPDATE_PROJECT, project);
export const deleteProjectList = (project : any) => api.delete(url.DELETE_PROJECT, { headers: { project } });

// Pages > Team
export const getTeamData = () => api.get(url.GET_TEAMDATA);
export const deleteTeamData = (team : any) => api.delete(url.DELETE_TEAMDATA, { headers: { team } });
export const addTeamData = (team : any) => api.create(url.ADD_NEW_TEAMDATA, team);
export const updateTeamData = (team : any) => api.put(url.UPDATE_TEAMDATA, team);

// File Manager

// Folder
export const getFolders = () => api.get(url.GET_FOLDERS);
export const deleteFolder = (folder : any) => api.delete(url.DELETE_FOLDER, { headers: { folder } });
export const addNewFolder = (folder : any) => api.create(url.ADD_NEW_FOLDER, folder);
export const updateFolder = (folder : any) => api.put(url.UPDATE_FOLDER, folder);

// File
export const getFiles = () => api.get(url.GET_FILES);
export const deleteFile = (file : any) => api.delete(url.DELETE_FILE, { headers: { file } });
export const addNewFile = (file : any) => api.create(url.ADD_NEW_FILE, file);
export const updateFile = (file : any) => api.put(url.UPDATE_FILE, file);

// To Do
export const getTodos = () => api.get(url.GET_TODOS);
export const deleteTodo = (todo : any) => api.delete(url.DELETE_TODO, { headers: { todo } });
export const addNewTodo = (todo : any) => api.create(url.ADD_NEW_TODO, todo);
export const updateTodo = (todo : any) => api.put(url.UPDATE_TODO, todo);

// To do Project
export const getProjects = () => api.get(url.GET_PROJECTS);
export const addNewProject = (project : any) => api.create(url.ADD_NEW_TODO_PROJECT, project);

//API Key
export const getAPIKey = () => api.get(url.GET_API_KEY);

//Job Application
export const getJobApplicationList = () => api.get(url.GET_APPLICATION_LIST);
export const addNewJobApplicationList = (job: any) => api.create(url.ADD_NEW_APPLICATION_LIST, job);
export const updateJobApplicationList = (job: any) => api.put(url.UPDATE_APPLICATION_LIST, job);
export const deleteJobApplicationList = (job: any) => api.delete(url.DELETE_APPLICATION_LIST, { headers: { job } });

// candidate list
export const getJobCandidateList = () => api.get(url.GET_CANDIDATE, '');
export const addJobCandidate = (candidate : any) => api.create(url.ADD_NEW_CANDIDATE, candidate);
export const updateJobCandidate = (candidate : any) => api.update(url.UPDATE_CANDIDATE, candidate);
export const deleteJobCandidate = (candidate : any) => api.delete(url.DELETE_CANDIDATE, { headers: {candidate} });

// category list
export const getcategoryList = () => api.get(url.GET_CATEGORY_LIST);
export const addcategoryList = (category : any) => api.create(url.ADD_CATEGORY_LIST, category);

// grid
export const getCandidateGrid = () => api.get(url.GET_CANDIDATE_GRID);
export const addCandidateGrid = (category : any) => api.create(url.ADD_CANDIDATE_GRID, category);

// Audit Logs - ADDED
// Get audit logs list with filters
export const getAuditLogs = (params?: any) => api.get(url.GET_AUDIT_LOGS, params);

// Get audit log by ID
export const getAuditLogById = (id: number) => api.get(`${url.GET_AUDIT_LOGS}/${id}`);

// Get audit logs statistics
export const getAuditLogStatistics = (params?: any) => api.get(url.GET_AUDIT_LOG_STATISTICS, params);

// Export audit logs (Excel or CSV)
export const exportAuditLogs = (params?: any) => api.get(url.EXPORT_AUDIT_LOGS, params);

// Get distinct modules hiện có trong AuditLog (đổ dropdown filter "Module")
export const getAuditLogModules = () => api.get(url.GET_AUDIT_LOG_MODULES);

// User Management - ADDED
// Get users list with filters
export const getUsers = (params?: any) => api.get(url.GET_USERS, params);

// Get user by ID
export const getUserById = (id: number) => api.get(`${url.GET_USER_BY_ID}/${id}`);

// Create user
export const createUser = (data: any) => api.create(url.CREATE_USER, data);

// Update user
export const updateUser = (id: number, data: any) => api.put(`${url.UPDATE_USER}`, data);

// Delete user
export const deleteUser = (id: number) => api.delete(`${url.DELETE_USER}/${id}`);

// Toggle user status (Lock/Unlock)
export const toggleUserStatus = (id: number, status: string) => api.update(`${url.TOGGLE_USER_STATUS}/${id}/status`, { status });

// Upload user avatar (same logic as uploadCurrentUserAvatar)
export const uploadUserAvatar = async (id: number, file: File) => {
  // Step 1: Upload to FileStorage
  const uploadResponse = await uploadFileToStorage('UserAvatars', file);
  const uploadData = uploadResponse.data || uploadResponse;
  const avatarUrl = uploadData.url;
  
  // Step 2: Update user's avatar URL in identity service
  // Try new API (JSON) first, fallback to old API (multipart) if 415 error
  try {
    const updateResponse = await api.create(`${url.UPLOAD_USER_AVATAR}/${id}/avatar`, {
      avatarUrl: avatarUrl
    });
    
    return {
      ...updateResponse,
      data: {
        objectKey: uploadData.objectKey,
        avatarUrl: avatarUrl,
      }
    };
  } catch (error: any) {
    // If backend returns 415 (Unsupported Media Type), try old API with file
    if (error?.response?.status === 415) {
      console.warn('Backend chưa hỗ trợ JSON upload, fallback sang multipart/form-data');
      const formData = new FormData();
      formData.append('avatar', file);
      await api.create(`${url.UPLOAD_USER_AVATAR}/${id}/avatar`, formData);
      
      // Return FileStorage URL anyway (ignore backend's placeholder URL)
      return {
        data: {
          objectKey: uploadData.objectKey,
          avatarUrl: avatarUrl,
        }
      };
    }
    throw error;
  }
};

// Update user permissions (gán RoleId cho User — mục 8.6, READE.md). Backend là [HttpPut], không
// phải api.update() (PATCH) như trước — chưa từng được gọi thật nên lỗi method mismatch này chưa lộ ra.
export const updateUserPermissions = (id: number, data: any) => api.put(`${url.UPDATE_USER_PERMISSIONS}/${id}/permissions`, data);

// Get departments list
export const getDepartments = () => api.get(url.GET_DEPARTMENTS);

// Get roles list (for user management dropdown)
export const getRoles = (params?: any) => api.get(url.GET_ROLES, params);


// Role Management - ADDED

// Get role groups list
export const getRoleGroups = (params?: any) => api.get(url.GET_ROLE_GROUPS, params);

// Get role group by ID
export const getRoleGroupById = (id: number) => api.get(`${url.GET_ROLE_GROUP_BY_ID}/${id}`);

// Create role group
export const createRoleGroup = (data: any) => api.create(url.CREATE_ROLE_GROUP, data);

// Update role group
export const updateRoleGroup = (id: number, data: any) => api.put(url.UPDATE_ROLE_GROUP, data);

// Assign role permissions
export const assignRolePermissions = (id: number, data: any) => api.put(`${url.UPDATE_ROLE_GROUP}/${id}/permissions`, data);

// Lấy danh sách flat PageActionInput codes của role thuộc user đang đăng nhập — gọi bởi
// slices/permission/thunk.ts#fetchMyPermissions (xem mục 9, README_SERCURITY.md)
export const getMyPageActionInputCodes = () => api.get(url.GET_MY_PAGE_ACTION_INPUT_CODES);

// Lấy danh sách path được phép truy cập của role thuộc user đang đăng nhập — BE cache ở Redis theo
// roleId. Gọi bởi slices/permission/thunk.ts#fetchMyPermissions, kết quả nạp vào Redux global state
// (state.Permission) thay vì gọi lại mỗi lần điều hướng (mục 9, README_SERCURITY.md)
export const getMyAllowedPaths = () => api.get(url.GET_MY_ALLOWED_PATHS);

// Get PageActionInput (action-button/input) đã gán cho role — dùng để set checked khi mở popup cập nhật quyền
export const getRolePageActionInputs = (id: number) => api.get(`${url.UPDATE_ROLE_GROUP}/${id}/page-action-inputs`);

// Assign PageActionInput (action-button/input) cho role
export const assignRolePageActionInputs = (id: number, data: any) => api.put(`${url.UPDATE_ROLE_GROUP}/${id}/page-action-inputs`, data);

// Quyền truy cập menu (RoleModuleMapping) — tách biệt hoàn toàn với assignRolePermissions cũ (RolePermission,
// không còn được GetUserMenuQuery sử dụng) và assignRoleApiPermissions (Phân quyền API). Xem mục 8,
// REQUIRE_ROLEMODULE_QA.md.
export const getRoleModules = (id: number) => api.get(`${url.UPDATE_ROLE_GROUP}/${id}/modules`);
export const assignRoleModules = (id: number, data: any) => api.put(`${url.UPDATE_ROLE_GROUP}/${id}/modules`, data);

// Delete role group
export const deleteRoleGroup = (id: number, forceDelete?: boolean) => {
  const config = forceDelete ? { params: { forceDelete: true } } : undefined;
  return api.delete(`${url.DELETE_ROLE_GROUP}/${id}`, config);
};

// Get modules
export const getModules = (isActive?: boolean) => api.get(url.GET_MODULES, isActive !== undefined ? { isActive } : undefined);

// Get dynamic sidebar menu tree (đã lọc theo quyền user hiện tại)
export const getUserMenu = () => api.get(url.GET_USER_MENU);

// Get permissions
export const getPermissions = (moduleId?: number, isActive?: boolean) => {
  const params: any = {};
  if (moduleId !== undefined) params.moduleId = moduleId;
  if (isActive !== undefined) params.isActive = isActive;
  return api.get(url.GET_PERMISSIONS, Object.keys(params).length > 0 ? params : undefined);
};

// Get permissions grouped by module
export const getPermissionsByModule = () => api.get(url.GET_PERMISSIONS_BY_MODULE);

// Module Management (quản lý module cha/con) - ADDED

// Get module detail by ID (dùng cho form edit)
export const getModuleById = (id: number) => api.get(`${url.GET_MODULE_BY_ID}/${id}`);

// Get permissions của một module
export const getModulePermissions = (id: number) => api.get(`${url.GET_MODULE_PERMISSIONS}/${id}/permissions`);

// Create module
export const createModule = (data: any) => api.create(url.CREATE_MODULE, data);

// Update module
export const updateModule = (id: number, data: any) => api.put(`${url.UPDATE_MODULE}/${id}`, data);

// Delete module (soft delete)
export const deleteModule = (id: number) => api.delete(`${url.DELETE_MODULE}/${id}`);

// Permission Management (tạo permission khi tạo module) - ADDED
export const createPermission = (data: any) => api.create(url.CREATE_PERMISSION, data);
export const deletePermission = (id: number) => api.delete(`${url.DELETE_PERMISSION}/${id}`);

// PageActionInput - catalog button/input trên từng trang FE, quét tự động ở Developer mode - ADDED
export const syncPageActionInputs = (items: { urlPage: string; code: string; name: string }[]) =>
  api.create(url.SYNC_PAGE_ACTION_INPUTS, { items });
export const getPageActionInputs = (urlPage?: string) =>
  api.get(url.GET_PAGE_ACTION_INPUTS, urlPage ? { urlPage } : undefined);

// API Permission - catalog quyền gọi API (quét tự động từ controller, tách biệt với Cập nhật
// permission/cây Module) - ADDED, mục 9 REQUIRE_FILTER.md
export const getApiPermissions = () => api.get(url.GET_API_PERMISSIONS);
export const getRoleApiPermissions = (id: number) => api.get(`${url.UPDATE_ROLE_GROUP}/${id}/api-permissions`);
export const assignRoleApiPermissions = (id: number, data: any) => api.put(`${url.UPDATE_ROLE_GROUP}/${id}/api-permissions`, data);

// System Configuration - ADDED

// Get system configuration
export const getSystemConfig = () => api.get(url.GET_SYSTEM_CONFIG);

// Lấy ngưỡng + tỷ lệ khấu trừ thuế TNCN (endpoint gọn, chỉ cần đăng nhập) — màn /claim-dossiers
// dùng để hiển thị đúng chữ thay cho fix cứng "10% > 10 triệu" (mục 7.1)
export const getTaxConfig = () => api.get(url.GET_TAX_CONFIG);

// Yêu cầu bổ sung (README_UPDATE.md) — lấy DUY NHẤT Miền đang cấu hình của hệ thống (endpoint gọn,
// chỉ cần đăng nhập). Nguồn sự thật cho màn Kết quả Quay số / Cơ cấu Giải thưởng.
export const getSystemRegionApi = () => api.get(url.GET_SYSTEM_REGION);

// Update region configuration — backend expose PUT, không phải PATCH nên phải dùng api.put
export const updateRegionConfig = (data: any) => api.put(url.UPDATE_REGION_CONFIG, data);

// Update lookup configuration — tương tự, backend expose PUT
export const updateLookupConfig = (data: any) => api.put(url.UPDATE_LOOKUP_CONFIG, data);

// Update hoa hồng trả thưởng mặc định — tương tự, backend expose PUT (mục 13.4)
export const updateCommissionConfig = (data: any) => api.put(url.UPDATE_COMMISSION_CONFIG, data);

// Update giá vé mặc định — tương tự, backend expose PUT (mục 8.g, README_UPDATE.md)
export const updatePriceConfig = (data: any) => api.put(url.UPDATE_PRICE_CONFIG, data);
export const updateTaxConfig = (data: any) => api.put(url.UPDATE_TAX_CONFIG, data);

// Update cấu hình "đại lý trả thưởng chéo" — backend expose PUT, hiệu lực ngay (mục 8.2, README_UPDATE.md)
export const updateCrossPrizePayoutConfig = (data: { allowAgentCrossPrizePayout: boolean }) =>
  api.put(url.UPDATE_CROSS_PRIZE_PAYOUT_CONFIG, data);

// Cập nhật thời hạn trả thưởng hợp lệ (ngày) — hiệu lực ngay
export const updatePrizeClaimValidityConfig = (data: { prizeClaimValidDays: number }) =>
  api.put(url.UPDATE_PRIZE_CLAIM_VALIDITY_CONFIG, data);

// Validate base URL
export const validateBaseUrl = (urlToValidate: string) => api.create(url.VALIDATE_URL, { url: urlToValidate });

// Xóa cache Redis "system-configuration" bên ticket-service ngay sau khi lưu cấu hình hệ thống
// thành công (xem slices/systemConfiguration/thunk.ts) - ADDED
export const invalidateTicketSystemConfigCache = () => api.create(url.INVALIDATE_TICKET_SYSTEM_CONFIG_CACHE, {});

// Branding Configuration - ADDED

// Get branding configuration
export const getBrandingConfig = () => api.get(url.GET_BRANDING_CONFIG);

// Update branding configuration
export const updateBrandingConfig = (data: any) => api.update(url.UPDATE_BRANDING_CONFIG, data);

// Upload logo
export const uploadLogo = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.create(url.UPLOAD_LOGO, formData);
};

// Delete logo
export const deleteLogo = () => api.delete(url.DELETE_LOGO);

// Upload favicon
export const uploadFavicon = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.create(url.UPLOAD_FAVICON, formData);
};

// Delete favicon
export const deleteFavicon = () => api.delete(url.DELETE_FAVICON);

// Get audit log for branding configuration
export const getBrandingAuditLog = (params?: any) => api.get(url.GET_AUDIT_LOG, params);
// Agent Management - ADDED

// Get agents list
export const getAgents = (params?: any) => api.get(url.GET_AGENTS, params);

// Create new agent
export const createNewAgent = (data: any) => api.create(url.CREATE_AGENT, data);

// Update existing agent
export const updateExistingAgent = (data: any) => api.put(url.UPDATE_AGENT, data);

// Check agent code availability
export const checkAgentCodeAvailability = (code: string) =>
  api.get(url.CHECK_AGENT_CODE, { params: { Code: code } });

// Lấy trước Mã đại lý sẽ được tự động sinh (mục 8.4, READE.md)
export const previewAgentCode = () => api.get(url.PREVIEW_AGENT_CODE);

// Cập nhật trạng thái đại lý (mục 8.8, READE.md)
export const updateAgentStatus = (id: number, status: string) =>
  api.put(`${url.UPDATE_AGENT_STATUS}/${id}/status`, { status });

// Change Password - ADDED
export const changeUserPassword = (userId: number, data: {confirmPassword: string; currentPassword: string; newPassword: string }) =>
  api.put(`${url.CHANGE_PASSWORD}${userId}/change-password`, data);



export const getUserProfile = (): Promise<any> => api.get(url.GET_USER_PROFILE);

export const updateUserProfile = (userId: number, data: any) => api.put(`${url.UPDATE_USER_PROFILE}/${userId}`, data);

// Upload file to FileStorage service
export const uploadFileToStorage = (screenName: string, file: File) => {
  const formData = new FormData();
  formData.append('screenName', screenName);
  formData.append('file', file);
  return api.create('/system-api/FileStorage', formData);
};

// Upload current user avatar (2-step: upload to FileStorage, then update user avatar in identity service)
export const uploadCurrentUserAvatar = async (userId: number, file: File) => {
  // Step 1: Upload to FileStorage
  const uploadResponse = await uploadFileToStorage('UserAvatars', file);
  const uploadData = uploadResponse.data || uploadResponse;
  const avatarUrl = uploadData.url;
  
  // Step 2: Update user's avatar URL in identity service
  // Try new API (JSON) first, fallback to old API (multipart) if 415 error
  try {
    const updateResponse = await api.create(`${url.UPLOAD_USER_AVATAR}/${userId}/avatar`, {
      avatarUrl: avatarUrl
    });
    
    return {
      ...updateResponse,
      data: {
        objectKey: uploadData.objectKey,
        avatarUrl: avatarUrl,
      }
    };
  } catch (error: any) {
    // If backend returns 415 (Unsupported Media Type), try old API with file
    if (error?.response?.status === 415) {
      console.warn('Backend chưa hỗ trợ JSON upload, fallback sang multipart/form-data');
      const formData = new FormData();
      formData.append('avatar', file);
      await api.create(`${url.UPLOAD_USER_AVATAR}/${userId}/avatar`, formData);
      
      // Return FileStorage URL anyway (ignore backend's placeholder URL)
      return {
        data: {
          objectKey: uploadData.objectKey,
          avatarUrl: avatarUrl,
        }
      };
    }
    throw error;
  }
};

// Tenant Management API helpers - ADD TO fakebackend_helper.ts

// Get tenants list
export const getTenants = (params?: any) => api.get(url.GET_TENANTS, params);

// Get tenant by ID
export const getTenantById = (id: number) => api.get(`${url.GET_TENANT_BY_ID}/${id}`);

// Create tenant
export const createTenant = (data: any) => api.create(url.CREATE_TENANT, data);

// Update tenant
export const updateTenant = (id: number, data: any) => api.put(`${url.UPDATE_TENANT}`, data);

// Delete tenant
export const deleteTenant = (id: number) => api.delete(`${url.DELETE_TENANT}/${id}`);

// Check tenant code availability
export const checkTenantCode = (code: string, excludeId?: number) => {
  const params = excludeId ? { Code: code, ExcludeId: excludeId } : { Code: code };
  return api.get(url.CHECK_TENANT_CODE, params);
};

// Get tenant managers list
export const getTenantManagers = () => api.get(url.GET_TENANT_MANAGERS);

// Ticket Lookup (tra cứu kết quả vé số qua QR — public, không cần đăng nhập)
// Token la chuoi base64url do ticket-service ma hoa (AES-256-GCM), tu chua ky quay/so ve/ky hieu
// nen chi can truyen nguyen token, khong con periodId/ticketNumber/symbol/sig rieng le - ADDED
export const lookupTicket = (token: string) =>
  api.get(`${url.LOOKUP_TICKET}/${encodeURIComponent(token)}`);

// Sinh chữ ký cho 1 vé cụ thể (Cổng tra cứu kết quả) — cần đăng nhập, dùng để lấy URL tra cứu
// map vào khối "Quét mã QR để tra cứu nhanh" thay vì phải quét QR in sẵn trên vé - ADDED
export const getTicketSignature = (periodId: number | string, ticketNumber: string, symbol: string) =>
  api.get(`${url.GET_TICKET_SIGNATURE}/${periodId}/${encodeURIComponent(ticketNumber)}/${encodeURIComponent(symbol)}`);

// Giải mã ngược 1 token đã sinh (kỳ/số vé/ký hiệu) — dùng để Cổng tra cứu kết quả tự điền lại form
// khi mở từ 1 vé cụ thể (VD: click vào thẻ vé trong màn "Tra cứu vé số vừa tạo") - ADDED
export const decodeTicketToken = (token: string) =>
  api.get(`${url.DECODE_TICKET_TOKEN}/${encodeURIComponent(token)}`);

// Ticket Design Template Management - ADDED

// Lấy danh sách templates với filters
export const getTicketDesignTemplates = (params?: any) => api.get(url.GET_TICKET_DESIGN_TEMPLATES, params);

// Lấy chi tiết template theo ID
export const getTicketDesignTemplateById = (id: number) => api.get(`${url.GET_TICKET_DESIGN_TEMPLATE_BY_ID}/${id}`);

// Lấy Signed URL để preview file
export const getTicketDesignTemplateFileUrl = (id: number) => api.get(`${url.GET_TICKET_DESIGN_TEMPLATE_FILE_URL}/${id}/file-url`);

// Tạo mới template
export const createTicketDesignTemplate = (data: any) => api.create(url.CREATE_TICKET_DESIGN_TEMPLATE, data);

// Cập nhật template
export const updateTicketDesignTemplate = (id: number, data: any) => api.put(`${url.UPDATE_TICKET_DESIGN_TEMPLATE}/${id}`, data);

export const updateTicketDesignTemplateFile = (id: number, file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.put(`${url.UPDATE_TICKET_DESIGN_TEMPLATE}/${id}/file`, formData);
};

export const deleteTicketDesignTemplateFile = (id: number) => api.delete(`${url.UPDATE_TICKET_DESIGN_TEMPLATE}/${id}/file`);

// Lưu vị trí/kích thước các phần tử overlay (mã vé, số vé, QR, ngày mở thưởng...) trên ảnh mẫu vé
export const updateTicketDesignTemplateLayout = (id: number, layoutJson: string | null) =>
  api.put(`${url.UPDATE_TICKET_DESIGN_TEMPLATE}/${id}/layout`, { layoutJson });

// Xóa template
export const deleteTicketDesignTemplate = (id: number) => api.delete(`${url.DELETE_TICKET_DESIGN_TEMPLATE}/${id}`);

// Phê duyệt template
export const approveTicketDesignTemplate = (id: number) => api.create(`${url.APPROVE_TICKET_DESIGN_TEMPLATE}/${id}/approve`, {});

export const unlockTicketDesignTemplate = (id: number) => api.create(`${url.UNLOCK_TICKET_DESIGN_TEMPLATE}/${id}/unlock`, {});

// Issuance Plan Management - ADDED
export const getIssuancePlans = (params?: any) => api.get(url.GET_ISSUANCE_PLANS, params);
export const getIssuancePlanById = (id: number) => api.get(`${url.GET_ISSUANCE_PLAN_BY_ID}/${id}`);
export const createIssuancePlan = (data: any) => api.create(url.CREATE_ISSUANCE_PLAN, data);
export const getIssuancePlanStatuses = () => api.get(url.GET_ISSUANCE_PLAN_STATUSES);
export const approveIssuancePlan = (id: number) => api.create(`${url.APPROVE_ISSUANCE_PLAN}/${id}/approve`, {});
export const rejectIssuancePlan = (id: number, reason: string) => api.create(`${url.REJECT_ISSUANCE_PLAN}/${id}/reject`, { reason });
export const cancelIssuancePlan = (id: number, reason: string) => api.create(`${url.REJECT_ISSUANCE_PLAN}/${id}/cancel`, { reason });
export const sendToPrintIssuancePlan = (id: number) => api.create(`${url.SEND_TO_PRINT_ISSUANCE_PLAN}/${id}/send-to-print`, {});
// "Duyệt tạo vé" — resume kế hoạch đã bị Hủy giữa lúc đang/đã sinh mã QR về lại đúng trạng thái cũ.
export const resumeTicketCreationIssuancePlan = (id: number) =>
  api.create(`${url.APPROVE_ISSUANCE_PLAN}/${id}/resume-ticket-creation`, {});
// Lịch sử chuyển trạng thái + các thao tác tác động lên 1 kế hoạch — dùng cho modal roadmap.
export const getIssuancePlanHistoryApi = (id: number) =>
  api.get(`${url.GET_ISSUANCE_PLAN_BY_ID}/${id}/history`);
export const downloadPrintPackageIssuancePlan = (id: number) => api.download(`${url.PRINT_PACKAGE_ISSUANCE_PLAN}/${id}/print-package`);
export const createPrintPackageExportJob = (id: number) => api.create(`${url.PRINT_PACKAGE_ISSUANCE_PLAN}/${id}/print-package/jobs`, {});
export const getPrintPackageExportJob = (jobId: string) =>
  api.get(`${url.PRINT_PACKAGE_ISSUANCE_PLAN}/print-package/jobs/${jobId}/progress`);
// Backend tra ve { url, fileName } — URL cong khai tren MinIO, KHONG proxy byte (goi in co the toi
// ~400MB) qua ticket-service. Goi triggerBrowserDownload(url) de tai truc tiep tu MinIO.
export const downloadPrintPackageExportJob = (jobId: string) =>
  api.get(`${url.PRINT_PACKAGE_ISSUANCE_PLAN}/print-package/jobs/${jobId}/download`);
// Hủy job export gói in — xem cancelQrGenerationJobApi.
export const cancelPrintPackageExportJobApi = (jobId: string, reason?: string) =>
  api.create(`${url.PRINT_PACKAGE_ISSUANCE_PLAN}/print-package/jobs/${jobId}/cancel`, { reason });
export const receiveWarehouseIssuancePlan = (id: number, actualReceivedQuantity: number) =>
  api.create(`${url.RECEIVE_WAREHOUSE_ISSUANCE_PLAN}/${id}/receive-warehouse`, { actualReceivedQuantity });

// Lịch sử lỗi job export gói in (bao gồm cả lỗi do StalledJobWatchdogService phát hiện)
export const getPrintPackageJobErrorLogsApi = (issuancePlanId: number) =>
  api.get(`${url.GET_PRINT_PACKAGE_JOB_ERROR_LOGS}/${issuancePlanId}/print-package/error-logs`);

// Lịch sử giao vé cho nhà in — ghi nhận sau khi kế hoạch đã "Gửi in" (SentPrint). Mật khẩu bảo vệ
// file ZIP không bao giờ trả về trong danh sách — chỉ qua revealPrintHouseDeliveryPasswordApi sau
// khi xác thực lại mật khẩu tài khoản (xem PasswordConfirmModal).
export const getPrintHouseDeliveriesApi = (params?: any) => api.get(url.GET_PRINT_HOUSE_DELIVERIES, params);
export const createPrintHouseDeliveryApi = (data: {
  issuancePlanId: number;
  printHouseName: string;
  address: string;
  password: string;
}) => api.create(url.CREATE_PRINT_HOUSE_DELIVERY, data);
export const revealPrintHouseDeliveryPasswordApi = (id: number, password: string) =>
  api.create(`${url.GET_PRINT_HOUSE_DELIVERIES}/${id}/reveal-password`, { password });

// Xác thực lại mật khẩu của chính tài khoản đang đăng nhập (self-service, không cấp token mới).
export const verifyCurrentUserPasswordApi = (password: string) =>
  api.create(url.VERIFY_CURRENT_USER_PASSWORD, { password });

// Xuất file ảnh QR (.png, gom theo thư mục Symbol, nén 1 file .zip) — luồng song song, độc lập với
// Gửi in/print-package ở trên. Cùng dùng thunk pattern.
export const createQrImageExportJob = (id: number) => api.create(`${url.PRINT_PACKAGE_ISSUANCE_PLAN}/${id}/qr-image/jobs`, {});
export const getQrImageExportJob = (jobId: string) =>
  api.get(`${url.PRINT_PACKAGE_ISSUANCE_PLAN}/qr-image/jobs/${jobId}/progress`);
// Backend trả về { url, fileName } — URL công khai trên MinIO, không proxy byte qua ticket-service.
export const downloadQrImageExportJob = (jobId: string) =>
  api.get(`${url.PRINT_PACKAGE_ISSUANCE_PLAN}/qr-image/jobs/${jobId}/download`);
// Hủy job xuất ảnh QR — xem cancelQrGenerationJobApi.
export const cancelQrImageExportJobApi = (jobId: string, reason?: string) =>
  api.create(`${url.PRINT_PACKAGE_ISSUANCE_PLAN}/qr-image/jobs/${jobId}/cancel`, { reason });
export const getQrImageJobErrorLogsApi = (issuancePlanId: number) =>
  api.get(`${url.GET_PRINT_PACKAGE_JOB_ERROR_LOGS}/${issuancePlanId}/qr-image/error-logs`);

// Ticket Type Management - ADDED
export const getTicketTypes = (params?: any) => api.get(url.GET_TICKET_TYPES, params);
export const getActiveTicketTypes = () => api.get(url.GET_ACTIVE_TICKET_TYPES);
export const getTicketTypeById = (id: number) => api.get(`${url.GET_TICKET_TYPE_BY_ID}/${id}`);
export const createTicketType = (data: any) => api.create(url.CREATE_TICKET_TYPE, data);
export const updateTicketType = (id: number, data: any) => api.put(`${url.UPDATE_TICKET_TYPE}/${id}`, data);
export const lockTicketType = (id: number) => api.create(`${url.LOCK_TICKET_TYPE}/${id}/lock`, {});
export const unlockTicketType = (id: number) => api.create(`${url.UNLOCK_TICKET_TYPE}/${id}/unlock`, {});
export const deleteTicketType = (id: number) => api.delete(`${url.DELETE_TICKET_TYPE}/${id}`);

// Sinh Bộ Số & QR Management - ADDED

// Lấy danh sách kỳ phát hành (filter Status=Published)
export const getKyPhatHanhListApi = (params?: any) => api.get(url.GET_KY_PHAT_HANH_LIST, params);

// Kích hoạt sinh bộ số & QR (POST body rỗng {})
export const sinhBoSoQrApi = (lotteryPeriodId: number) => 
  api.create(`${url.SINH_BO_SO_QR}/${lotteryPeriodId}`, {});

// Lấy tiến trình job (fallback polling)
export const getJobProgressApi = (jobId: string) => 
  api.get(`${url.SINH_BO_SO_QR}/jobs/${jobId}/progress`);

export const getActiveTicketJobsApi = () =>
  api.get(`${url.SINH_BO_SO_QR}/jobs/active`);

// Hủy job sinh bộ số & QR — nếu job còn "pending" sẽ hủy ngay, nếu đang "processing" sẽ báo
// QrGenerationJobConsumer tự dừng ở checkpoint gần nhất (xem CancelQrGenerationJobCommand).
export const cancelQrGenerationJobApi = (jobId: string, reason?: string) =>
  api.create(`${url.SINH_BO_SO_QR}/jobs/${jobId}/cancel`, { reason });

export const verifyTicketGenerationApi = (lotteryPeriodId: number) =>
  api.get(`${url.SINH_BO_SO_QR}/${lotteryPeriodId}/verify`);

// Tra cứu 1 vé/dải vé bất kỳ trong bộ vé vừa sinh của 1 kỳ phát hành
export const searchGeneratedTicketsApi = (
  lotteryPeriodId: number,
  numberFrom?: string,
  numberTo?: string,
  symbol?: string
) => api.get(`${url.SINH_BO_SO_QR}/${lotteryPeriodId}/search-tickets`, { numberFrom, numberTo, symbol });

// Lịch sử lỗi job sinh QR (bao gồm cả lỗi do StalledJobWatchdogService phát hiện)
export const getQrJobErrorLogsApi = (lotteryPeriodId: number) =>
  api.get(`${url.GET_QR_JOB_ERROR_LOGS}/${lotteryPeriodId}/error-logs`);

// Toàn bộ lịch sử lỗi job sinh QR (mọi kỳ phát hành), có phân trang — truyền targetId để lọc theo
// 1 kỳ cụ thể, không truyền (undefined) để xem tất cả. Dùng cho tab "Quản lý kế hoạch lỗi".
export const getAllQrJobErrorLogsApi = (
  pageIndex: number,
  pageSize: number,
  targetId?: number,
) => {
  const params: any = { pageIndex, pageSize };
  if (targetId !== undefined) params.targetId = targetId;
  return api.get(`${url.SINH_BO_SO_QR}/error-logs`, params);
};

// Danh sách các dải số bị lỗi khi sinh bộ số & QR chạy đa luồng — dùng cho tab "Quản lý kế hoạch lỗi"
export const getTicketGenerationRangeErrorsApi = (lotteryPeriodId: number) =>
  api.get(`${url.SINH_BO_SO_QR}/${lotteryPeriodId}/range-errors`);

// Rerun lại 1 dải số bị lỗi cụ thể (không chạy lại toàn bộ job)
export const rerunTicketGenerationRangeErrorApi = (rangeErrorId: number) =>
  api.create(`${url.SINH_BO_SO_QR}/range-errors/${rangeErrorId}/rerun`, {});

// Export CSV (streaming download)
export const exportQrCsvApi = (lotteryPeriodId: number) => 
  api.get(`${url.EXPORT_QR_CSV}/${lotteryPeriodId}/export-csv`, {
    responseType: 'blob',
  });

// Prize Structure Management (Cơ cấu Giải thưởng) - ADDED
// Rewrite: chỉ còn cấu hình tĩnh 10 hạng giải, dùng chung mọi kỳ — không còn theo issuancePlanId.
// Thêm chiều Miền (Miền Bắc/Miền Trung/Miền Nam) — mỗi miền có cơ cấu riêng, region truyền qua query param
// (GET/initialize/delete) hoặc trong body (PUT) — khớp PayoutRegions bên payout-service.

// Danh mục 10 hạng giải cố định kèm Quantity/ValuePerTicket/TotalValue/MatchingRule, của 1 miền
export const getPrizeTierConfigsApi = (region: string) => api.get(url.GET_PRIZE_TIER_CONFIGS, { region });

// Lưu cấu hình cả 10 hạng giải cùng lúc (1 nút "Lưu cấu hình") của 1 miền
export const updatePrizeTierConfigsApi = (data: { region: string; tiers: any[] }) =>
  api.put(url.UPDATE_PRIZE_TIER_CONFIGS, data);

// Thêm 1 hạng giải mới vào cơ cấu của 1 miền ("+ Thêm hạng giải")
export const createPrizeTierConfigApi = (data: {
  region: string;
  code: string;
  displayName: string;
  colorTheme: string;
  digitCondition: number;
  quantity: number;
  valuePerTicket: number;
  matchingRule: string;
  matchingPosition: string | null;
  matchingDigits: number | null;
}) => api.create(url.UPDATE_PRIZE_TIER_CONFIGS, data);

// Khởi tạo 10 hạng giải mặc định khi cơ cấu của 1 miền đang rỗng
export const initializePrizeTierConfigsApi = (region: string) =>
  api.create(`${url.INITIALIZE_PRIZE_TIER_CONFIGS}?region=${encodeURIComponent(region)}`, {});

// Xoá (soft-delete) 1 hạng giải khỏi cơ cấu của 1 miền, VD bỏ hẳn Giải Tám nếu không dùng
export const deletePrizeTierConfigApi = (region: string, code: string) =>
  api.delete(`${url.DELETE_PRIZE_TIER_CONFIG}/${code}?region=${encodeURIComponent(region)}`);

// Draw Result Management (Kết quả Quay số) - ADDED

// Kết quả quay số (số trúng thật) của 1 kỳ đang chọn, theo miền đang chọn trên FE
export const getDrawResultByPlanApi = (issuancePlanId: number, region: string) =>
  api.get(`${url.GET_DRAW_RESULT_BY_PLAN}/${issuancePlanId}`, { region });

// Lưu kết quả quay số của 1 kỳ (ghi đè toàn bộ, theo miền)
export const saveDrawResultApi = (issuancePlanId: number, data: { region: string; entries: any[] }) =>
  api.put(`${url.SAVE_DRAW_RESULT}/${issuancePlanId}`, data);

// Danh sách IssuancePlanId đã có kết quả quay số (bất kỳ miền nào) — dùng lọc dropdown "Kỳ vé" ở màn Tạo Hồ sơ
// Kết quả Trúng thưởng.
export const getIssuancePlanIdsWithDrawResultApi = () =>
  api.get(url.GET_ISSUANCE_PLAN_IDS_WITH_DRAW_RESULT);

// Đọc danh sách Kỳ phát hành từ ticket-service (chỉ đọc, cross-service)
export const getIssuancePlansApi = (params?: any) => api.get(url.GET_ISSUANCE_PLANS, params);

// Brand Management - ADDED

// Lấy thông tin thương hiệu hiện tại
export const getBrandInfo = () => api.get(url.GET_BRAND_INFO);

// Cập nhật thông tin thương hiệu
export const updateBrand = (data: any) => api.put(url.UPDATE_BRAND_INFO, data);

// Upload logo
export const uploadBrandLogo = (formData: FormData) =>
  api.create(url.UPLOAD_BRAND_LOGO, formData);

// Xóa logo
export const deleteBrandLogo = () => api.delete(url.DELETE_BRAND_LOGO);

// Notification Management - ADDED

// Lấy danh sách thông báo (phân trang/lọc)
export const getNotifications = (params?: any) => api.get(url.GET_NOTIFICATIONS, params);

// Lấy số lượng thông báo chưa đọc
export const getNotificationUnreadCount = () => api.get(url.GET_NOTIFICATION_UNREAD_COUNT);

// Đánh dấu 1 thông báo đã đọc
export const markNotificationAsRead = (id: number | string) =>
  api.put(`${url.MARK_NOTIFICATION_READ}/${id}/read`, {});

// Đánh dấu tất cả thông báo đã đọc
export const markAllNotificationsAsRead = () => api.put(url.MARK_ALL_NOTIFICATIONS_READ, {});

// Prize Claim Dossier (Thẩm định Hồ sơ Trả thưởng) - ADDED

// Danh sách hồ sơ (phân trang, lọc theo trạng thái/CCCD/số vé — cũng dùng để "tra cứu nhanh" FR-002)
export const getClaimDossiersApi = (params?: any) => api.get(url.GET_CLAIM_DOSSIERS, params);

// Chi tiết 1 hồ sơ
export const getClaimDossierByIdApi = (id: number) => api.get(`${url.GET_CLAIM_DOSSIER_BY_ID}/${id}`);

// Tạo hồ sơ mới — server tự chấm vé + tự tính Thuế TNCN, KHÔNG gửi prizeTierCode/prizeAmount
export const createClaimDossierApi = (data: {
  issuancePlanId: number;
  symbol: string;
  ticketNumber: string;
  // Mục 7 (README.md §7) — nhóm thông tin cá nhân optional: chỉ bắt buộc khi giá trị giải thưởng gốc
  // vượt ngưỡng cấu hình (validate ở CreateClaimDossierModal + backend).
  claimantName?: string;
  claimantIdNumber?: string;
  bankName?: string;
  bankAccountName?: string;
  bankAccountNumber?: string;
  idCardFrontImageUrl?: string | null;
  idCardBackImageUrl?: string | null;
}) => api.create(url.CREATE_CLAIM_DOSSIER, data);

// Ký duyệt hồ sơ
export const approveClaimDossierApi = (id: number) => api.create(`${url.APPROVE_CLAIM_DOSSIER}/${id}/approve`, {});

// Hủy hồ sơ
export const cancelClaimDossierApi = (id: number, reason?: string) =>
  api.create(`${url.CANCEL_CLAIM_DOSSIER}/${id}/cancel`, { reason });

// Kế toán Chi trả — "Chuyển khoản": ChuaChi -> DaChi (chỉ áp dụng hồ sơ đã Thẩm định)
export const payClaimDossierApi = (id: number) => api.create(`${url.PAY_CLAIM_DOSSIER}/${id}/pay`, {});

// README.md muc 9 — "Tham dinh" (buoc 1) va "Hau kiem" (buoc 2, chi sau khi Tham dinh Phe duyet)
// cho ho so do dai ly tu tao (AgentPaid).
export const appraiseClaimDossierApi = (id: number, decision: string, comment?: string) =>
  api.create(`${url.APPRAISE_CLAIM_DOSSIER}/${id}/appraise`, { decision, comment });
export const postAuditClaimDossierApi = (id: number, decision: string, comment?: string) =>
  api.create(`${url.POST_AUDIT_CLAIM_DOSSIER}/${id}/post-audit`, { decision, comment });

// Bổ sung — thông tin trả thưởng đại lý của 1 hồ sơ do đại lý tự lập: đại lý nào trả thưởng, hình
// thức trực tiếp/chéo, nếu chéo thì vé thuộc lô vé (phiếu giao) nào và phân cho đại lý nào.
export const getAgentPayoutInfoApi = (id: number) =>
  api.get(`${url.GET_AGENT_PAYOUT_INFO}/${id}/agent-payout-info`);

// Xem trước Giải trúng/Giá trị giải thưởng gốc + Thuế TNCN/Thực lĩnh khi nhập đủ Kỳ vé + Số vé — KHÔNG lưu DB
export const previewClaimDossierApi = (params: { issuancePlanId: number; ticketNumber: string }) =>
  api.get(url.PREVIEW_CLAIM_DOSSIER, { IssuancePlanId: params.issuancePlanId, TicketNumber: params.ticketNumber });

// Quét ảnh CCCD mặt trước (OCR local, không lưu DB) để gợi ý điền sẵn Họ và tên/Số CCCD — CHỈ mang tính gợi ý,
// nhân viên phải kiểm tra lại trước khi lưu.
export const scanCccdImageApi = (file: File) => {
  const formData = new FormData();
  formData.append('File', file);
  return api.create(url.SCAN_CCCD_CLAIM_DOSSIER, formData);
};

// ===========================================================================
// Phân hệ Giao vé cho đại lý (README_TICKETHANDLE.md — mục 4.7)
// ===========================================================================

// Danh sách phiếu giao vé: ?agentId=&planId=&status=&pageIndex=&pageSize=
export const getTicketDeliveriesApi = (params?: any) => api.get(url.TICKET_DELIVERY, params);

// Chi tiết 1 phiếu giao (kèm các dòng Symbol + dải số)
export const getTicketDeliveryByIdApi = (id: number) => api.get(`${url.TICKET_DELIVERY}/${id}`);

// Tạo phiếu giao ở trạng thái Draft
export const createTicketDeliveryApi = (data: any) => api.create(url.TICKET_DELIVERY, data);

// Sửa các dòng của phiếu khi còn Draft
export const updateTicketDeliveryApi = (id: number, data: any) =>
  api.put(`${url.TICKET_DELIVERY}/${id}`, data);

// Xác nhận giao vé: Draft -> Confirmed (BE ghi ledger + trừ/cộng tồn trong 1 transaction)
export const confirmTicketDeliveryApi = (id: number) =>
  api.create(`${url.TICKET_DELIVERY}/${id}/confirm`, {});

// Huỷ phiếu khi còn Draft
export const cancelTicketDeliveryApi = (id: number, reason?: string) =>
  api.create(`${url.TICKET_DELIVERY}/${id}/cancel`, { reason });

// Đại lý xác nhận đã nhận vé: Confirmed -> AgentConfirmed (mục 13.2, không ảnh hưởng tồn kho)
export const agentConfirmTicketDeliveryApi = (id: number) =>
  api.create(`${url.TICKET_DELIVERY}/${id}/agent-confirm`, {});

// Tồn kho hiện tại theo Symbol: bỏ trống agentId = tồn kho tổng công ty
export const getTicketStockBalancesApi = (params: { planId: number; agentId?: number }) =>
  api.get(url.TICKET_STOCK_BALANCE, params);

// Danh sách kỳ + tổng đã giao/còn lại (màn "Tồn kho vé theo kế hoạch") — ?pageIndex=&pageSize=
export const getTicketStockOverviewApi = (params?: any) =>
  api.get(url.TICKET_STOCK_BALANCE_OVERVIEW, params);

// Mục 11.a, README_UPDATE.md — dải số ĐÃ GIAO thực sự cho 1 đại lý (khác tồn kho còn lại), phục vụ
// auto-fill form lập phiếu thu hồi. symbol bỏ trống = lấy tất cả ký hiệu.
export const getTicketDeliveredRangesApi = (params: { planId: number; agentId?: number; symbol?: string }) =>
  api.get(url.TICKET_STOCK_BALANCE_DELIVERED_RANGES, params);

// Mục 3, README.md (Cập nhật) — dải số CÒN TRỐNG (chưa giao cho đại lý nào) của 1 ký hiệu trong kế
// hoạch, phục vụ auto-fill form lập phiếu giao vé (thay vì fill nguyên dải số của cả kế hoạch).
export const getAvailableDeliveryRangesApi = (params: { planId: number; symbol: string }) =>
  api.get(url.TICKET_STOCK_BALANCE_AVAILABLE_RANGES, params);

// Mục 4 (README.md §7) — kiểm tra 1 dải số (planId + symbol + rangeStart + rangeEnd) có trùng với
// phiếu giao vé KHÁC đang active không; trả về mảng { symbol, rangeStart, rangeEnd, agentId, deliveryCode }.
export const checkDeliveryRangeOverlapApi = (params: {
  planId: number;
  symbol: string;
  rangeStart: string;
  rangeEnd: string;
}) => api.get(url.TICKET_STOCK_BALANCE_CHECK_RANGE_OVERLAP, params);

// Mục 4 (README.md §7) — lấy 1 đại lý theo Id (để resolve tên đại lý trong cảnh báo trùng dải).
export const getAgentByIdApi = (id: number) => api.get(`${url.GET_AGENTS}/${id}`);

// ===========================================================================
// Phân hệ Thu hồi vé ế (REQUIRE_FIXBUGS.md mục 13.3) — không chọn đại lý
// ===========================================================================

export const getTicketRecallsApi = (params?: any) => api.get(url.TICKET_RECALL, params);

export const getTicketRecallByIdApi = (id: number) => api.get(`${url.TICKET_RECALL}/${id}`);

export const createTicketRecallApi = (data: any) => api.create(url.TICKET_RECALL, data);

export const confirmTicketRecallApi = (id: number) =>
  api.create(`${url.TICKET_RECALL}/${id}/confirm`, {});

export const cancelTicketRecallApi = (id: number, reason?: string) =>
  api.create(`${url.TICKET_RECALL}/${id}/cancel`, { reason });

// Mục 23, REQUIRE_FIXBUGS.md — Duyệt/Từ chối phiếu thu hồi vé ế đã Confirmed (lưu trực tiếp trên
// TicketRecall, không tách bảng riêng).
export const approveTicketRecallApi = (id: number, comment?: string) =>
  api.create(`${url.TICKET_RECALL}/${id}/approve`, { comment });

export const rejectTicketRecallApi = (id: number, comment: string) =>
  api.create(`${url.TICKET_RECALL}/${id}/reject`, { comment });

// Mục 8.f, README_UPDATE.md — gán/đổi vị trí kho lưu trữ cho phiếu thu hồi đã Duyệt (Approved).
export const assignTicketRecallWarehouseLocationApi = (id: number, warehouseLocation: string) =>
  api.create(`${url.TICKET_RECALL}/${id}/warehouse-location`, { warehouseLocation });

// Mục 8.3 (README_UPDATE.md) + README_QR_SCAN_PERFORMANCE.md — quét QR (qua ảnh) để Thu hồi vé.
// Thu hồi: có thể bỏ agentId và gửi vé quét đầu tiên (anchorSymbol + anchorTicketNumber) — server tự lấy
// đại lý đang được giao vé đó làm đại lý thu hồi của phiên.
export const openTicketScanSessionApi = (data: {
  scanType: number;
  issuancePlanId: number;
  agentId?: number;
  anchorSymbol?: string;
  anchorTicketNumber?: string;
}) =>
  api.create(`${url.TICKET_SCAN}/sessions`, data);
export const decodeTicketScanBatchApi = (data: { tokens: string[] }) =>
  api.create(`${url.TICKET_SCAN}/decode-batch`, data);
export const ingestTicketScanEntriesApi = (
  sessionId: number,
  data: { clientBatchId: string; clientBatchSeq: number; entries: any[] },
) => api.create(`${url.TICKET_SCAN}/sessions/${sessionId}/entries`, data);
export const getTicketScanSessionApi = (sessionId: number, includeRanges = false) =>
  api.get(`${url.TICKET_SCAN}/sessions/${sessionId}`, { includeRanges });
export const cancelTicketScanSessionApi = (sessionId: number) =>
  api.create(`${url.TICKET_SCAN}/sessions/${sessionId}/cancel`, {});
export const finalizeTicketScanSessionApi = (sessionId: number, note?: string) =>
  api.create(`${url.TICKET_SCAN}/sessions/${sessionId}/finalize`, { note });

// ===========================================================================
// Module báo cáo (REQUIRE_FIXBUGS.md mục 24)
// ===========================================================================

export const getIssuancePlanReportApi = (params?: any) => api.get(url.REPORTS_ISSUANCE_PLAN, params);

export const getTicketDeliveryByAgentReportApi = (params?: any) =>
  api.get(url.REPORTS_TICKET_DELIVERY_BY_AGENT, params);

export const getTicketRecallByAgentReportApi = (params?: any) =>
  api.get(url.REPORTS_TICKET_RECALL_BY_AGENT, params);

export const getDashboardSummaryApi = () => api.get(url.REPORTS_DASHBOARD_SUMMARY);

// dac-ta-bao-cao-cong-no-dai-ly.md — báo cáo công nợ đại lý (Sổ cái) + chi tiết + điều chỉnh.
export const getAgentDebtReportApi = (params?: any) => api.get(url.REPORTS_AGENT_DEBT, params);
export const getAgentDebtDetailApi = (agentId: number, params?: any) =>
  api.get(`${url.REPORTS_AGENT_DEBT}/${agentId}/detail`, params);
export const getAgentDebtLedgerApi = (agentId: number, params?: any) =>
  api.get(`${url.REPORTS_AGENT_DEBT}/${agentId}/ledger`, params);
export const getAgentCashFlowLedgerApi = (agentId: number, params?: any) =>
  api.get(`${url.REPORTS_AGENT_DEBT}/${agentId}/cashflow`, params);
export const getAgentDebtByPeriodApi = (agentId: number, params?: any) =>
  api.get(`${url.REPORTS_AGENT_DEBT}/${agentId}/by-period`, params);
export const rebuildAgentDebtApi = (agentId?: number) =>
  api.create(agentId ? `${url.REPORTS_AGENT_DEBT_REBUILD}?agentId=${agentId}` : url.REPORTS_AGENT_DEBT_REBUILD, {});

// Điều chỉnh công nợ (§10) — quyền "reports.debt-adjustment".
export const getAgentDebtAdjustmentsApi = (params?: any) => api.get(url.REPORTS_AGENT_DEBT_ADJUSTMENT, params);
export const createAgentDebtAdjustmentApi = (data: any) => api.create(url.REPORTS_AGENT_DEBT_ADJUSTMENT, data);
export const setAgentDebtAdjustmentStatusApi = (id: number, data: any) =>
  api.create(`${url.REPORTS_AGENT_DEBT_ADJUSTMENT}/${id}/set-status`, data);

// Export (§30) — build query string thủ công, download blob (giống exportReport.ts).
const buildAgentDebtQuery = (params: Record<string, any>): string =>
  Object.keys(params || {})
    .filter((k) => params[k] !== null && params[k] !== undefined && params[k] !== '')
    .map((k) => `${k}=${encodeURIComponent(params[k])}`)
    .join('&');

export const downloadAgentDebtSummaryExport = async (params: Record<string, any>, format: 'Xlsx' | 'Csv') => {
  const q = buildAgentDebtQuery({ ...params, format });
  const res = await api.download(`${url.REPORTS_AGENT_DEBT}/export/summary?${q}`);
  triggerBlobDownload(res, `BaoCaoCongNoDaiLy_TongHop_${Date.now()}.${format === 'Xlsx' ? 'xlsx' : 'csv'}`);
};

export const downloadAgentDebtDetailExport = async (agentId: number, params: Record<string, any>, format: 'Xlsx' | 'Csv') => {
  const q = buildAgentDebtQuery({ ...params, format });
  const res = await api.download(`${url.REPORTS_AGENT_DEBT}/${agentId}/export/detail?${q}`);
  triggerBlobDownload(res, `BaoCaoCongNoDaiLy_ChiTiet_${agentId}_${Date.now()}.${format === 'Xlsx' ? 'xlsx' : 'csv'}`);
};

const triggerBlobDownload = (response: any, fileName: string) => {
  const blob = new Blob([response?.data ?? response]);
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
};

export const getTicketDeliveryDetailApi = (params?: any) =>
  api.get(url.REPORTS_TICKET_DELIVERY_DETAIL, params);

export const getTicketRecallDetailApi = (params?: any) =>
  api.get(url.REPORTS_TICKET_RECALL_DETAIL, params);

// ===========================================================================
// Yêu cầu hoàn vé ế tại quầy (US-016/US-017)
// ===========================================================================

// Tìm yêu cầu hoàn vé theo mã đại lý / mã phiếu yêu cầu
export const getUnsoldTicketReturnRequestsApi = (params?: any) =>
  api.get(url.UNSOLD_TICKET_RETURN_REQUEST, params);

// Chi tiết 1 yêu cầu (kèm bảng so sánh khai báo vs thực đếm)
export const getUnsoldTicketReturnRequestByIdApi = (id: number) =>
  api.get(`${url.UNSOLD_TICKET_RETURN_REQUEST}/${id}`);

// Tạo yêu cầu hoàn vé ế (dùng chung với App Đại lý — US-014/US-015)
export const createUnsoldTicketReturnRequestApi = (data: any) =>
  api.create(url.UNSOLD_TICKET_RETURN_REQUEST, data);

// Ghi nhận 1 lần quét QR khi kiểm đếm vé vật lý tại quầy
// Ghi nhận kết quả quét đếm — id nằm trên PATH, body là danh sách vé vừa quét. Gọi được nhiều
// lần, server cộng dồn vào phiếu đối soát đang mở (ScanCountUnsoldTicketReturnRequestCommand).
export const scanCountUnsoldTicketApi = (
  id: number,
  tickets: Array<{ ticketNumber: string; symbol: string; rejectReason?: string }>,
) => api.create(`${url.UNSOLD_TICKET_RETURN_REQUEST}/${id}/scan-count`, { tickets });

// ===========================================================================
// Phiếu đối soát thu hồi vé ế — thẩm định (US-018), lưu kho & báo cáo (US-019)
// ===========================================================================

// Danh sách phiếu đối soát: ?status=&agentId=&issuancePlanId=&pageIndex=&pageSize=
export const getTicketReturnReconciliationsApi = (params?: any) =>
  api.get(url.TICKET_RETURN_RECONCILIATION, params);

// Chi tiết 1 phiếu đối soát (vé hợp lệ/bị loại + file biên bản)
export const getTicketReturnReconciliationByIdApi = (id: number) =>
  api.get(`${url.TICKET_RETURN_RECONCILIATION}/${id}`);

// Lập phiếu đối soát từ yêu cầu đã kiểm đếm đủ 100%.
// Nhận FormData khi có "Biên bản bất hợp lệ" đính kèm (bắt buộc nếu rejectedQuantity > 0).
// Controller khai báo [Consumes("multipart/form-data")] — LUÔN phải gửi FormData, kể cả khi
// không đính kèm file (field: returnRequestId, note, allowMissing, attachment).
export const createTicketReturnReconciliationApi = (data: FormData) =>
  api.create(url.TICKET_RETURN_RECONCILIATION, data);

// Thẩm định: Phê duyệt / Từ chối / Yêu cầu đối soát lại
export const appraiseTicketReturnReconciliationApi = (
  id: number,
  data: { decision: string; comment?: string },
) => api.create(`${url.TICKET_RETURN_RECONCILIATION}/${id}/appraise`, data);

// Gán vị trí kho lưu trữ vật lý cho phiếu đã thẩm định + phê duyệt
export const setTicketReturnWarehouseLocationApi = (
  id: number,
  data: { warehouseLocation: string; note?: string },
) => api.create(`${url.TICKET_RETURN_RECONCILIATION}/${id}/warehouse-location`, data);

// KHÔNG có endpoint `/{id}/file-url` riêng: GET danh sách và GET chi tiết đã sinh sẵn
// `attachmentUrl` (signed URL, TTL 1h) qua IStorageService.GenerateSignedUrlAsync.

// Báo cáo nhanh thu hồi vé ế — LƯU Ý param tên `PeriodId` (giá trị truyền vào là IssuancePlanId)
export const getTicketReturnReportApi = (params?: { PeriodId?: number; AgentId?: number }) =>
  api.get(`${url.TICKET_RETURN_RECONCILIATION}/report`, params);

// Export báo cáo (Excel/PDF) — streaming download dạng blob
export const exportTicketReturnReportApi = (params: Record<string, any>) => {
  const query = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value !== null && value !== undefined && value !== '') {
      query.append(key, String(value));
    }
  });
  const queryString = query.toString();
  return api.download(
    `${url.TICKET_RETURN_RECONCILIATION}/report/export${queryString ? `?${queryString}` : ''}`,
  );
};

// ===========================================================================
// Báo cáo phát hành vé số (RPT-001→018) + Quản lý nhà in (README.md mục 7 — module
// IssuanceReporting). Export/xem chi tiết không định nghĩa hàm riêng — dùng
// downloadReportExport (pages/Reports/IssuanceReporting/shared/exportReport.ts).
// ===========================================================================

// --- IssuanceReportsController — 12 báo cáo đọc thuần (PaginatedList<T>) ---
export const getIssuanceSummaryReportApi = (params?: any) =>
  api.get(`${url.ISSUANCE_REPORTS_BASE}/IssuanceSummary`, params);
export const getIssuanceRangeReportApi = (params?: any) =>
  api.get(`${url.ISSUANCE_REPORTS_BASE}/IssuanceRange`, params);
export const getPrintHouseReceiptReportApi = (params?: any) =>
  api.get(`${url.ISSUANCE_REPORTS_BASE}/PrintHouseReceipts`, params);
export const getTicketStockReportApi = (params?: any) =>
  api.get(`${url.ISSUANCE_REPORTS_BASE}/Stock`, params);
export const getTicketDistributionReportApi = (params?: any) =>
  api.get(`${url.ISSUANCE_REPORTS_BASE}/Distribution`, params);
export const getTicketDeliveryLineReportApi = (params?: any) =>
  api.get(`${url.ISSUANCE_REPORTS_BASE}/DeliveryLines`, params);
export const getTicketRecallSummaryReportApi = (params?: any) =>
  api.get(`${url.ISSUANCE_REPORTS_BASE}/RecallSummary`, params);
export const getTicketRecallLineReportApi = (params?: any) =>
  api.get(`${url.ISSUANCE_REPORTS_BASE}/RecallLines`, params);
export const getTicketSoldReportApi = (params?: any) =>
  api.get(`${url.ISSUANCE_REPORTS_BASE}/Sold`, params);
export const getAgentSummaryReportApi = (params?: any) =>
  api.get(`${url.ISSUANCE_REPORTS_BASE}/AgentSummary`, params);
export const getPrintHouseSummaryReportApi = (params?: any) =>
  api.get(`${url.ISSUANCE_REPORTS_BASE}/PrintHouseSummary`, params);

// --- IssuanceReportsController — single-object, không phân trang/export (RPT-015/016/017) ---
export const getIssuancePeriodSummaryReportApi = (planId: number) =>
  api.get(`${url.ISSUANCE_REPORTS_BASE}/PeriodSummary/${planId}`);
export const lookupTicketReportApi = (params: any) =>
  api.get(`${url.ISSUANCE_REPORTS_BASE}/TicketLookup`, params);
export const lookupTicketRangeReportApi = (params: any) =>
  api.get(`${url.ISSUANCE_REPORTS_BASE}/RangeLookup`, params);

// --- AgentReconciliationController (RPT-009) — có workflow xác nhận ---
export const getPaginatedAgentReconciliationsApi = (params?: any) =>
  api.get(url.AGENT_RECONCILIATION, params);
export const confirmAgentReconciliationApi = (data: any) =>
  api.create(`${url.AGENT_RECONCILIATION}/confirm`, data);

// --- TicketDiscrepancyController (RPT-010) — ghi nhận + xử lý chênh lệch ---
export const getPaginatedTicketDiscrepanciesApi = (params?: any) =>
  api.get(url.TICKET_DISCREPANCY, params);
export const createTicketDiscrepancyApi = (data: any) => api.create(url.TICKET_DISCREPANCY, data);
export const resolveTicketDiscrepancyApi = (id: number, data: any) =>
  api.create(`${url.TICKET_DISCREPANCY}/${id}/resolve`, data);

// --- TicketCancellationController (RPT-014) — chỉ đọc, auto-log từ BE ---
export const getPaginatedTicketCancellationsApi = (params?: any) =>
  api.get(url.TICKET_CANCELLATION, params);

// --- PeriodClosingController (RPT-018) — có workflow chốt kỳ ---
export const getPeriodClosingApi = (planId: number) => api.get(`${url.PERIOD_CLOSING}/${planId}`);
export const closePeriodApi = (data: any) => api.create(`${url.PERIOD_CLOSING}/close`, data);

// --- PrintHouseController — danh mục Nhà in (CRUD) ---
export const getPrintHouses = (params?: any) => api.get(url.PRINT_HOUSE, params);
export const getPrintHouseById = (id: number) => api.get(`${url.PRINT_HOUSE}/${id}`);
export const createPrintHouse = (data: any) => api.create(url.PRINT_HOUSE, data);
export const updatePrintHouse = (data: any) => api.put(url.PRINT_HOUSE, data);
export const deletePrintHouse = (id: number) => api.delete(`${url.PRINT_HOUSE}/${id}`);
